import { addGlobalContexts, clearGlobalContexts, trackSelfDescribingEvent } from '@snowplow/browser-tracker';

type SubscriptionTrackingPayload = {
  termId: string;
  chargeAmount: string;
  paymentMethod: string;
};

let isDriveTrackerReady = false;
const pendingSubscriptionEvents: SubscriptionTrackingPayload[] = [];

function buildSubscriptionContext(payload: SubscriptionTrackingPayload) {
  return {
    schema: 'iglu:de.drive/subscription_context/jsonschema/1-0-0',
    data: {
      action: 'conversion',
      label: 'thankyou-page',
      product: payload.termId,
      price: payload.chargeAmount,
      payment_method: payload.paymentMethod,
    },
  };
}

function sendSubscriptionEvent(payload: SubscriptionTrackingPayload) {
  const subscriptionContext = buildSubscriptionContext(payload);

  clearGlobalContexts();
  addGlobalContexts([subscriptionContext]);
  trackSelfDescribingEvent({
    event: subscriptionContext,
  });
}

export function markSnowplowTrackerReady() {
  isDriveTrackerReady = true;

  while(pendingSubscriptionEvents.length > 0) {
    const pendingEvent = pendingSubscriptionEvents.shift();

    if(pendingEvent) {
      sendSubscriptionEvent(pendingEvent);
    }
  }
}

export function trackSubscriptionWithSnowPlow(termId: string, chargeAmount: string, paymentMethod: string) {
  if(!termId) {
    return;
  }

  const payload = {
    termId,
    chargeAmount,
    paymentMethod,
  };

  if(!isDriveTrackerReady) {
    pendingSubscriptionEvents.push(payload);
    return;
  }

  sendSubscriptionEvent(payload);
}